import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function SingleRightArrow({ width = 24, height = 24, color = 'black' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z"
        fill={color}
      />
    </Svg>
  );
}

export default SingleRightArrow;
